import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IonContent } from '@ionic/react';

import { screen } from '$fcomponents/hoc';
import { TableView2, Header } from '$gcomponents/widgets';

import { WAREHOUSE_TABLE, WAREHOUSE_TABLE_CONFIG } from './warehouseTable';
import { IonPageWrapper } from './styles';
import FactoryModel from '$fbusiness/models/factory';
import CurrentStateModel from '$fbusiness/models/currentState';
import ItemActionModel from '$gbusiness/models/itemAction';
import { factoryActions } from '$fbusiness/redux/factory';
import { dialog } from '$gcomponents/reusables';
import { configs } from '$configs';
import FabButton from '$fcomponents/fabButton';
import { accessHide, isAccessible, updatedFilter } from '$fbusiness/helpers/util';
import { ACCESS } from '$fbusiness/enums/access';
import WarehouseEditModal from './warehouseEditModal';
import { initialWarehouse } from '$fbusiness/models/warehouse';

interface WarehousesScreenProps {
  factory: FactoryModel;
  currentState: CurrentStateModel;
  deleteWarehouse;
}

const WarehousesScreen: React.FC<WarehousesScreenProps> = ({ factory, deleteWarehouse, currentState }) => {
  const [warehouse, setWarehouse] = useState<any>(null);
  const [filter, setFilter] = useState({ forceRefresh: false });

  const { warehouses } = factory;

  if (!factory) return <IonPageWrapper />;

  const onCloseModal = async () => {
    setWarehouse(null);
  };

  const refreshList = () => {
    setFilter(updatedFilter(filter, {}));
  };

  const itemActions: Array<ItemActionModel> = [
    {
      label: 'BUTTON.EDIT',
      eventName: 'editItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.WAREHOUSE.EDIT, currentState),
      onClick: setWarehouse,
    },
    {
      label: 'BUTTON.DELETE',
      eventName: 'deleteItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.WAREHOUSE.DELETE, currentState),
      onClick: (row) => {
        dialog.confirm({
          message: 'MESSAGE.DELETE_WARNING',
          onPress: async () => {
            await deleteWarehouse(row.id, configs.api.warehouse.general, factoryActions.fetchWarehouses);
          },
        });
      },
    },
  ];

  return (
    <IonPageWrapper>
      <Header title="SCREEN.WAREHOUSES.TITLE" />
      <IonContent>
        <TableView2
          filter={filter}
          tableConfig={WAREHOUSE_TABLE_CONFIG}
          data={warehouses}
          TABLE={WAREHOUSE_TABLE()}
          itemActions={itemActions}
        />
      </IonContent>
      <WarehouseEditModal warehouse={warehouse} refreshList={refreshList} onClose={onCloseModal} />
      <FabButton
        onClick={() => setWarehouse(initialWarehouse)}
        className={accessHide(ACCESS.ACTION.SETTING.WAREHOUSE.CREATE)}
      />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  deleteWarehouse: factoryActions.deleteObj,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(WarehousesScreen));
